import React, { useContext } from 'react'

import { TitleContext } from '@providers/TitleProvider'
import { useSession } from '@stores/globalData/globalData.store'
import { isLearnPcPreview } from '@utils/page-routes'

import PrintPdfButton from './PrintPdfButton'
import PurchaseToPrintButton from './PurchaseToPrintButton'

const PurchaseOrPrintButton: React.FC = () => {
  const { title } = useContext(TitleContext)
  const session = useSession()

  // There shouldn't be a Purchase to Print for an EEi score.
  if (title.isEE()) return null

  if (isLearnPcPreview()) return null

  const printable = title.complimentary || title.isOwnedByUser() || title.isAuthorizedForUser()

  // Student's shouldn't see the Purchase to Print button (but can see Print PDF)
  if (!printable && !session.isDefaultCommunity() && !session.isSiteAdminOrTeacher()) return null
  if (printable) return <PrintPdfButton />

  if (session.isDefaultCommunity()) return <PurchaseToPrintButton />
  return null
}

export default PurchaseOrPrintButton
